// Required Fields Configuration
const requiredFieldsConfig = {
  basic: [
    "cDataEmail",
    "cDataCountry",
    "cDataBillingFirstName",
    "cDataBillingLastName",
    "cDataBillingAddress",
    "cDataBillingZip",
    "cDataBillingCity",
    "cDataPhone",
  ],
  shipping: [
    "cDataShippingFirstName",
    "cDataShippingLastName",
    "cDataShippingAddress",
    "cDataShippingZip",
    "cDataShippingCity",
  ],
};

// Function to validate all required fields and return invalid elements
const validateOrderData = () => {
  const invalidFields = [];

  // Validate basic required fields
  requiredFieldsConfig.basic.forEach((inputId) => {
    const inputElement = document.getElementById(inputId);
    if (!inputElement || !inputElement.value.trim()) {
      markFieldAsInvalid(inputElement);
      invalidFields.push(inputElement);
    } else {
      markFieldAsValid(inputElement);
    }
  });

  // Validate shipping fields if differentShippingAddress is true
  if (differentShippingAddress) {
    requiredFieldsConfig.shipping.forEach((inputId) => {
      const inputElement = document.getElementById(inputId);
      if (!inputElement || !inputElement.value.trim()) {
        markFieldAsInvalid(inputElement);
        invalidFields.push(inputElement);
      } else {
        markFieldAsValid(inputElement);
      }
    });
  }

  return invalidFields;
};

// Helper Functions for Visual Feedback
const markFieldAsInvalid = (inputElement) => {
  if (inputElement) {
    setTimeout(() => {
      inputElement.classList.add("invalid-field");
      const nextElement = inputElement.nextElementSibling;
      if (nextElement && nextElement.tagName === "LABEL") {
        nextElement.classList.add("invalid-field-label");
        if (!nextElement.textContent.includes("(povinné)")) {
          nextElement.textContent += " (povinné)";
        }
      }
    }, 100);
  }
};

const markFieldAsValid = (inputElement) => {
  if (inputElement) {
    inputElement.classList.remove("invalid-field");
    const nextElement = inputElement.nextElementSibling;
    if (nextElement && nextElement.tagName === "LABEL") {
      nextElement.classList.remove("invalid-field-label");
      nextElement.textContent = nextElement.textContent.replace(
        " (povinné)",
        ""
      );
    }
  }
};

// Function to validate shipping and payment methods and return invalid elements
const validateShippingAndPaymentMethods = () => {
  const invalidElements = [];

  // Validate shipping method
  if (!shippingMethod) {
    const shippingError = document.querySelector(
      ".n_checkout-system--shipping-invalid"
    );
    shippingError.classList.add("visible");
    invalidElements.push(document.getElementById("shippingFormSection"));
  } else {
    clearShippingError();
  }

  // Conditional validation for selected point if shippingType is "point"
  if (shippingType === "point" && !pointId) {
    const shippingError = document.querySelector(
      ".n_checkout-system--shipping-invalid"
    );
    invalidElements.push(document.getElementById("shippingFormSection"));
  }

  // Validate payment method
  if (!paymentMethod) {
    const paymentError = document.querySelector(
      ".n_checkout-system--payment-invalid"
    );
    paymentError.classList.add("visible");
    invalidElements.push(document.getElementById("paymentFormSection"));
  } else {
    clearPaymentError();
  }

  return invalidElements;
};

// Function to scroll to elements in sequence
const scrollToInvalidElements = (elements) => {
  if (elements.length > 0) {
    elements[0].scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

// Real-Time Validation Setup
document.addEventListener("DOMContentLoaded", () => {
  requiredFieldsConfig.basic.forEach((inputId) => {
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.addEventListener("blur", () => validateField(inputElement));
      inputElement.addEventListener("input", () => validateField(inputElement));
    }
  });

  requiredFieldsConfig.shipping.forEach((inputId) => {
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.addEventListener("blur", () => validateField(inputElement));
      inputElement.addEventListener("input", () => validateField(inputElement));
    }
  });
});

// Validate a single field
const validateField = (inputElement) => {
  if (!inputElement.value.trim()) {
    markFieldAsInvalid(inputElement);
  } else {
    markFieldAsValid(inputElement);
  }
};

// Function to handle clearing errors for payment and shipping
const clearPaymentError = () => {
  const paymentErrorElement = document.querySelector(
    ".n_checkout-system--payment-invalid"
  );
  if (paymentErrorElement) {
    paymentErrorElement.classList.remove("visible");
  }
};

const clearShippingError = () => {
  const shippingErrorElement = document.querySelector(
    ".n_checkout-system--shipping-invalid"
  );
  if (shippingErrorElement) {
    shippingErrorElement.classList.remove("visible");
  }
};

// Function to validate required checkboxes
const validateRequiredCheckboxes = () => {
  const requiredCheckboxes = document.querySelectorAll(
    'input[type="checkbox"][data-required="true"]'
  );
  const invalidCheckboxes = [];

  requiredCheckboxes.forEach((checkbox) => {
    if (!checkbox.checked) {
      markCheckboxAsInvalid(checkbox);
      invalidCheckboxes.push(checkbox);
    } else {
      markCheckboxAsValid(checkbox);
    }
  });

  return invalidCheckboxes;
};

// Helper function to visually mark a checkbox as invalid
const markCheckboxAsInvalid = (checkbox) => {
  const spanElement = checkbox
    .closest(".checkbox-wrapper")
    .querySelector(".checkbox");
  if (spanElement) {
    spanElement.classList.add("invalid-checkbox");
  }

  // Add 'invalid' class to the label associated with the checkbox
  const label = document.querySelector(`label[for="${checkbox.id}"]`);
  if (label) {
    label.classList.add("invalid");
  }
};

// Helper function to visually mark a checkbox as valid
const markCheckboxAsValid = (checkbox) => {
  const spanElement = checkbox
    .closest(".checkbox-wrapper")
    .querySelector(".checkbox");
  if (spanElement) {
    spanElement.classList.remove("invalid-checkbox");
  }

  // Remove 'invalid' class from the label associated with the checkbox
  const label = document.querySelector(`label[for="${checkbox.id}"]`);
  if (label) {
    label.classList.remove("invalid");
  }
};

// Function to remove a specified cookie by name
function removeNCookie(cookieName) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  console.log(`${cookieName} cookie removed`);
}

// Function to clear the cart and remove the n_CheckoutSession cookie
async function clearCartAndRemoveSession() {
  try {
    // Make the POST request to "/cart/clear.js"
    const response = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      console.log("Cart cleared successfully");
    } else {
      console.error("Failed to clear the cart:", response.statusText);
    }

    removeNCookie("n_checkoutSession");
  } catch (error) {
    console.error("Error while clearing the cart:", error);
  }
}

// Constructing the body of order details
function createOrderDataBody() {
  const inputEmail = document.getElementById("cDataEmail")?.value || "";
  const inputPhone = document.getElementById("cDataPhone")?.value || "";

  const inputBillingCompany =
    document.getElementById("cDataBillingCompany")?.value || "";
  const inputBillingCId =
    document.getElementById("cDataBillingCId")?.value || "";
  const inputBillingVAT =
    document.getElementById("cDataBillingVAT")?.value || "";
  const inputBillingFirstName =
    document.getElementById("cDataBillingFirstName")?.value || "";
  const inputBillingLastName =
    document.getElementById("cDataBillingLastName")?.value || "";
  const inputBillingAddress =
    document.getElementById("cDataBillingAddress")?.value || "";
  const inputBillingZip =
    document.getElementById("cDataBillingZip")?.value || "";
  const inputBillingCity =
    document.getElementById("cDataBillingCity")?.value || "";

  const inputShippingFirstName = differentShippingAddress
    ? document.getElementById("cDataShippingFirstName")?.value || ""
    : inputBillingFirstName;
  const inputShippingLastName = differentShippingAddress
    ? document.getElementById("cDataShippingLastName")?.value || ""
    : inputBillingLastName;
  const inputShippingAddress = differentShippingAddress
    ? document.getElementById("cDataShippingAddress")?.value || ""
    : inputBillingAddress;
  const inputShippingZip = differentShippingAddress
    ? document.getElementById("cDataShippingZip")?.value || ""
    : inputBillingZip;
  const inputShippingCity = differentShippingAddress
    ? document.getElementById("cDataShippingCity")?.value || ""
    : inputBillingCity;

  const glsPoint = shippingMethod === 'gls_point_cz' ? window.__botasGlsPoint : null;
  if (shippingMethod === 'gls_point_cz' && (!glsPoint || glsPoint.point_id !== pointId)) {
    alert('Vyberte prosím výdejní místo GLS.');
    return;
  }

  // Construct JSON body with grouped fields
  const orderDataBody = {
    customer: {
      email: inputEmail,
      phone: inputPhone,
      customerId: "",
      isCustomer: false,
    },
    billing_address: {
      company: inputBillingCompany,
      cid: inputBillingCId,
      vat: inputBillingVAT,
      firstName: inputBillingFirstName,
      lastName: inputBillingLastName,
      province: "",
      address: inputBillingAddress,
      address2: "",
      zip: inputBillingZip,
      city: inputBillingCity,
      country: selectedCountry,
    },
    differentShippingAddress: differentShippingAddress,
    shipping_address: {
      firstName: inputShippingFirstName,
      lastName: inputShippingLastName,
      province: "",
      address: glsPoint ? glsPoint.address : inputShippingAddress,
      address2: "",
      zip: glsPoint ? glsPoint.zip : inputShippingZip,
      city: glsPoint ? glsPoint.city : inputShippingCity,
      country: selectedCountry,
    },
    payment_method: {
      method: paymentMethod,
    },
    shipping_method: {
      shippingMethod: shippingMethod,
      shippingType: shippingType,
      pointId: pointId,
      pointName: pointName,
    },
    discount: {
      discountCode: discountCode,
      discountStatus: discountStatus,
      discountType: discountType,
    },
    pricing: {
      priceSubtotal: priceSubtotal,
      priceDiscount: priceDiscount,
      priceShipping: priceShipping,
      pricePayment: pricePayment,
      priceTip: priceTip,
      priceTotal: priceTotal,
      vatSubtotal: vatSubtotal,
      vatDiscount: vatDiscount,
      vatShipping: vatShipping,
      vatPayment: vatPayment,
      vatTip: vatTip,
      vatTotal: vatTotal,
    },
    cart: cart,
    cartNote: "",
    session: {
      market: market,
      currency: currency,
      currencySymbol: currencySymbol,
      marketVatRate: marketVatRate,
      domain: domain,
      checkoutSession: checkoutSession,
    },
    consent: {
      acceptMarketing: acceptMarketing,
      acceptTerms: acceptTerms,
      acceptPrivacy: acceptPrivacy,
    },
    tip: {
      amount: 0,
      is: false,
    },
  };

  // Log to verify the structure
  console.log(orderDataBody);

  // Return the JSON object for use in an API call
  return orderDataBody;
}

// Function to send order data and handle payment if necessary
const submitOrderData = async () => {
  const orderDataBody = createOrderDataBody();
  if (!orderDataBody) return;

  // Attach Lidl code if present (set by lidl-gate.liquid or sessionStorage)
  const lidlCode = window.__lidl_code || sessionStorage.getItem('lidl_active_code');
  if (lidlCode) {
    orderDataBody.lidl_code = lidlCode;
  }

  try {
    const response = await fetch("/a/api/createorder", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(orderDataBody),
    });

    if (!response.ok) {
      throw new Error(`Error creating order: ${response.statusText}`);
    }

    const orderData = await response.json();
    console.log(orderData);

    if (paymentMethod === "gateway") {
      fetch("/a/api/initiate-payment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          orderNo: orderData.order.order_id,
          amount: priceTotal,
          currency: currency,
          language: language,
          returnUrl: `https://${window.domain}/pages/status?nox=${orderData.order.order_hash}&npt=true`,
          returnMethod: `GET`,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Payment initiation failed: ${response.statusText}`
            );
          }
          return response.json();
        })
        .then((paymentData) => {
          fetch(`/a/api/updateorder/${orderData.order.order_hash}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ payment_gatewayId: paymentData.payId }),
          })
            .then((patchResponse) => {
              if (!patchResponse.ok) {
                throw new Error(
                  `Error updating order: ${patchResponse.statusText}`
                );
              }
              return patchResponse.json();
            })
            .then((patchData) => {
              if (paymentData.redirectUrl) {
                window.location.href = paymentData.redirectUrl;
              }
            });
        });
    } else {
      const statuspageurl = `https://${window.domain}/pages/status?nox=${orderData.order.order_hash}&npt=true`;
      window.location.href = statuspageurl;
    }
  } catch (error) {
    alert("There was an error processing your order. Please try again.");
    removeLoading();
  }
};

const visualHandleSubmitBtn = () => {
  const sBtnTitle = document.querySelectorAll(
    ".n_checkout-system--confirm-order_button-title"
  );
  const sBtnLoading = document.querySelectorAll(
    ".n_checkout-system--confirm-order_button-loading"
  );

  sBtnTitle.forEach((btn) => btn.classList.remove("visible"));
  sBtnLoading.forEach((btn) => btn.classList.add("visible"));
};

document
  .getElementById("confirmOrderButton")
  .addEventListener("click", (event) => {
    event.preventDefault();

    const invalidFields = validateOrderData();
    const invalidMethods = validateShippingAndPaymentMethods();
    const invalidCheckboxes = validateRequiredCheckboxes();

    if (
      invalidFields.length === 0 &&
      invalidMethods.length === 0 &&
      invalidCheckboxes.length === 0
    ) {
      setLoading();
      clearCartAndRemoveSession();
      submitOrderData();
      visualHandleSubmitBtn();
    } else {
      scrollToInvalidElements([
        ...invalidFields,
        ...invalidMethods,
        ...invalidCheckboxes,
      ]);
    }
  });
